<template>
    <div id="editCert" class="app-inner">
        <div class="public-btn-small flex align-cen posta">
            <div class="public-btn-small-plan"  style="margin-left:0" @click="$util.reback('/certiFicateStInfo')">
            返回
            </div>
           <el-button type="primary"  :loading="loading" class="public-btn-small-primary public-btn-small-load" style="margin-left:16px"
           @click="openSub('ruleForm')"
            >
             {{$route.query.id ? '修改' : '保存'}}
           </el-button>
            </div>
             <div class="edit-from">
                     <div class="public-tit flex align-cen">
            <div class="public-tit-list">
                <i class="icon-al-database-fill"></i>  基本信息
            </div>
        </div>
         <el-form ref="ruleForm" :model="form" label-width="150px" :rules="rules" class="flex align-cen">
                <el-form-item label="姓名：" prop="name">
                    <el-input v-model="form.name" placeholder="请输入姓名【1-50】" clearable></el-input>
             </el-form-item>
                 <el-form-item label="手机号：" prop="phone">
                    <el-input v-model="form.phone" placeholder="请输入手机号" clearable></el-input>
             </el-form-item>
               <el-form-item label="身份证号：" prop="idNo">
                    <el-input v-model="form.idNo" placeholder="请输入身份证号" clearable></el-input>
             </el-form-item>
                  <el-form-item label="学员照片：" prop="pic">
                    <el-upload
                    class="avatar-uploader"
                    :action="$config.baseUrl + '/admin/sys-file/upload'"
                    :headers="headers"
                    :show-file-list="false"
                    :on-success="handleAvatarSuccess"
                    :before-upload="$util.beforeUpload"
                    :disabled="uploadBoolean"
                    >
                    <div slot="tip" class="el-upload__tip" >建议尺寸：<span style="color:#f56c6c">180*240</span></div>
                    <img :src="form.pic" class="avatar" v-if="form.pic">
                    <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                       <!--页面新增删除和预览-->
                    <span v-if="form.pic" class="el-upload-list__item-actions">
                        <span class="upload-icon">
                            <span class="el-uploads-span" style="margin-right: 10px;" @click.stop="oploadImgPre">
                                <i class="el-icon-zoom-in"></i>
                            </span>
                            <span class="el-upload-span" @click.stop="oploadImgDel">
                                <i class="el-icon-delete"></i>
                            </span>
                        </span>
                    </span> 
                    <el-dialog :visible.sync="oploadDialogVisible" size="tiny" :append-to-body="true" :show-close="false">
                        <img width="100%" :src="form.pic" alt="">
                    </el-dialog>
                    </el-upload>
                 </el-form-item>
         </el-form>
             </div>
    </div>
</template>
<script>
import {editCertInfo,deletCert} from "@/api/index/index"   //新增学员证书信息、查询证书
import Format from "../../../../utils/auth.js";
import debounce from '../../../../utils/debounce.js' //防抖
export default {
    data () {
        return {
        uploadBoolean:false,
        oploadDialogVisible:false,
          loading:false,  
          headers:{},
          form:{
            name:'',
            phone:'',
            idNo:'',
            pic:''
          },
          rules:{
             name: [{ required: true, message: '请输入姓名', trigger: 'blur' },
             { min: 1, max: 50, message: '长度在 1 到 50 个字符', trigger: 'blur' }
             ],
             phone: [
                {
                    validator: Format.FormValidate.Form().Phone, //validator： 自定义验证规则
                    trigger: "blur",
                    message: "请正确输入手机号",
                    required: true,
                },
                ],
            idNo: [
                {
                    validator: Format.FormValidate.Form().ID, //validator： 自定义验证规则
                    trigger: "blur",
                    message: "请正确输入身份证号",
                    required: true,
                },
            ],
            pic:[{ required: true, message: '请上传学员照片', trigger: 'blur' }],
          }
        }
    },
    created () {
        if(this.$route.query.id) this.getDetail()
        let token = this.$locaStorage.setAge().get('token')
        if(token){
            this.headers = {
                'Authorization': token
            }
        }
    },
    methods: {
            getDetail(){
            deletCert({id:this.$route.query.id},'get')
            .then(res =>{
               this.form = {
                name:res.data.name,
                phone:res.data.phone,
                idNo:res.data.idNo,
                pic:res.data.pic
                }
            })
            .catch(err =>{})
        },
        // 保存
        openSub(formName){
        let params = {};
         let method = "post"
         if(!this.$route.query.id) params = {...this.form},method = "post";
         if(this.$route.query.id) params = {...this.form,id:this.$route.query.id}, method = "put";
           this.$refs[formName].validate((valid) => {  
                     if(valid){
                 //防抖提交
                    debounce(() => {
                        this.commentBness(params,method)
                    }, 500)
                        }else{
                          this.$util.Notifi('请填写或上传必填项','error','fa-exclamation-circle');
                        }
                    }) 
        },
             commentBness(params,method){
               this.loading = true
                editCertInfo(params,method)
                        .then(res => {
                           if(res.code == 0){
                            this.loading = false
                            if(!this.$route.query.id) this.$message.success('新增成功')
                                setTimeout(() => {
                           this.$router.push({
                            name:'certiFicateStInfo',
                            query:{
                            }
                           })
                             }, 100);
                           }else{
                             this.loading = false
                            this.$message.error(res.msg)
                           }
                        })
                        .catch(err => {
                           this.loading = false
                        })
        },
             // 图片放大
         oploadImgPre(){
            this.oploadDialogVisible = true
            },
        oploadImgDel(){
            this.form.pic = ''
                let _this= this
                setTimeout(function(){
                    _this.uploadBoolean = false
                },1000)
        },
         handleAvatarSuccess(res, file) {
        this.form.pic = res.data.url
        
        if(this.form.pic){
        this.uploadBoolean = true
         }
      },
    },
}
</script>
<style lang="scss" scoped>
   .edit-from{
         margin-bottom: 44px;
         .edit-from-tit{
             background: rgb(215, 215, 215);
             padding: 10px 20px;
             font-size: 18px;
         }
           .el-form{
            flex-wrap: wrap;
            margin-top: 20px;
         .el-form-item{
            width: 50%;
        .el-input,.el-cascader{
            width: 80%;
        }
        .el-select,.el-input-group{
            width: 80%;
        }
        .el-textarea{
            width: 80%;
        }
        
        }
         }
         .App-tab{
            margin: 20px 0;
            
        }
         }
           ::v-deep{
 .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 80px;
    height: 80px;
    line-height: 80px;
    text-align: center;
  }
  
  .avatar {
    width: 180px;
    height: 240px;
    display: block;
  }
  .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 200px;
        height: 200px;
        line-height: 200px;
        text-align: center;
    }
   .upload-icon {
        position: absolute;
        top: 50%;
        margin-left: -28px;
        margin-top: -18px;
    }
    .uploadPicture{
        position: absolute;
        bottom: 0;
        width: 100%;
        height: 50px;
        background: rgba(0,0,0,.6);
        color: #fff;
        line-height: 50px;
        text-align: center;
    }
    .el-dialog{
        width: 50%;
    }
  }
</style>